import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { blogPosts } from "@/data/blogPosts";

export const BlogPage: React.FC = () => {
  return (
    <div className="pt-24 pb-20 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <span className="text-xs font-extrabold uppercase tracking-widest text-primary bg-primary/10 px-3 py-1 rounded-md">
            Insights & Real Estate Articles
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            Feingold Property Insights
          </h1>
          <p className="text-slate-600 dark:text-slate-300 text-base">
            Expert commentary, market trends, and asset management guides for
            property owners.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post, i) => (
            <div
              key={i}
              className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-md overflow-hidden flex flex-col justify-between"
            >
              <div className="p-6">
                <span className="text-[10px] font-bold uppercase tracking-wider text-accent bg-accent/10 px-2.5 py-1 rounded-md mb-3 inline-block">
                  {post.category}
                </span>
                <Link to={`/blog/${post.slug}`}>
                  <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3 hover:text-primary transition-colors cursor-pointer">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-slate-600 dark:text-slate-400 text-xs leading-relaxed mb-4">
                  {post.excerpt}
                </p>
              </div>

              <div className="p-6 pt-0 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between text-xs text-slate-400 mt-4">
                <span className="flex items-center gap-1.5">
                  <Calendar className="w-3.5 h-3.5" /> {post.date}
                </span>
                <Link
                  to={`/blog/${post.slug}`}
                  className="font-bold text-primary flex items-center gap-1 hover:underline cursor-pointer"
                >
                  Read Article <ArrowRight className="w-3 h-3" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
